import { createStore, applyMiddleware, combineReducers } from 'redux';
import thunk from 'redux-thunk';

import { reducer as sessionReducer } from './slices/session';
import { reducer as profileReducer } from './slices/profile';
import { reducer as welcomeReducer } from './slices/welcome';

// `reducers` and `extraArgument` are how a platform adds what only it needs: the
// web app passes @zippeditoolsjs/heimdal-react's branch and client through them.
// `services` is merged in last so an added extra argument cannot shadow it and
// cut the app's own thunks off from the client they call.
export default function _createStore(
  services,
  { reducers, extraArgument } = {},
) {
  return createStore(
    combineReducers({
      ...reducers,
      session: sessionReducer,
      profile: profileReducer,
      welcome: welcomeReducer,
    }),
    applyMiddleware(thunk.withExtraArgument({ ...extraArgument, services })),
  );
}
